export const GET_TOTAL_RECORD = 'GET_DASHBOARD_TOTAL_RECORD';
export const GET_BANK_TRANSFER_RECORD = 'GET_DASHBOARD_BANK_TRANSFER_RECORD';
export const GET_FPAY_RECORD = 'GET_DASHBOARD_FPAY_RECORD';
export const GET_WITHDRAW_RECORD = 'GET_DASHBOARD_WITHDRAW_RECORD';
export const GET_DDATA = 'GET_DASHBOARD_DDATA';
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";

